import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import './index.css';
import Dropdown from "../Dropdown";
import RightMenu from "../RightMenu";

export default class View_type_12 extends Component{

  constructor(props){
    super(props);
    let data = {html: '', multimedia: [], prev_dropdown: [], right_menu: [], ...props.data};

    //console.log(props);
    this.state = {
      data: data,
      config: props.config,
      prevDropdown: data.prev_dropdown
    };
    let search = "/*change*/";
    let styles = '.sponsor-label {background-color: #'+this.state.config.gbcolor+'}';
    this.state.data.html = this.state.data.html.replace(search, styles);

  }

  render(){
    return(

      // <div className="vt12">
      //   <div className="vt12 html" dangerouslySetInnerHTML={{ __html: this.state.data.html }}></div>
      // </div>

      <div className="vt12 container-fluid">
        <div
          className={`
              ? "vt8 row vt10--flex-nav"
              : "vt8 row"
          `}
        >
          <div className="vt8 col-xs-12 col-sm-12 col-md-0 col-lg-9">
            <div className="vt8 col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <div className="vt12 html" dangerouslySetInnerHTML={{ __html: this.state.data.html }}></div>
            </div>
          </div>
          <div
            className={`
                ? "vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3 dropdown--nav-flex"
                : "vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3"
            `}
          >
            {this.state.prevDropdown.length ||
            Object.keys(this.state.prevDropdown).length ? (
              <Dropdown
                giveMeClassName={`${
                  this.state.prevDropdown.dates.length > 5
                    ? "festiwal--dropdown"
                    : "normal"
                }`}
                data={this.state.prevDropdown}
              />
            ) : null}
            <RightMenu data={this.state.data.right_menu}/>
          </div>
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_12/index.js